// extracted by mini-css-extract-plugin
export var arrowButton = "Carousels-module--arrowButton--ad283";
export var bottomBar = "Carousels-module--bottomBar--a700d";
export var buttonContainer = "Carousels-module--buttonContainer--ff4a2";
export var cards = "Carousels-module--cards--f626c";
export var contactUs = "Carousels-module--contactUs--cc2ea";
export var container = "Carousels-module--container--b3347";
export var disabledButton = "Carousels-module--disabledButton--7f638";
export var innerContainer = "Carousels-module--innerContainer--e911a";
export var introductionText = "Carousels-module--introductionText--fb5fa";
export var nextIcons = "Carousels-module--nextIcons--21ad5";
export var readMore = "Carousels-module--readMore--6bb9d";
export var readMoreContainer = "Carousels-module--readMoreContainer--289ab";
export var scrollCard = "Carousels-module--scrollCard--dd2bd";